<template>
  <v-layout row wrap grid-list-md justify-center>
    <v-flex sm12 mb-0 pa-0>
      <v-tabs v-model="orderBy" show-arrows class="boldfont">
        <v-icon class='tab-icon'>swap_vert</v-icon>
        <v-tab
          ripple
          v-for="sortOption in sortOptions"
          :key="sortOption"
        >{{ $vuetify.t('$vuetify.IdeaListing.sortBy' + sortOption) }}</v-tab>
        <translate-button></translate-button>
        <v-text-field
          v-model="query"
          flat
          :label="$vuetify.t('$vuetify.IdeaListing.search')"
          prepend-inner-icon="search"
          solo-inverted
        ></v-text-field>
      </v-tabs>
    </v-flex>
    <v-flex sm12 mb-0 pa-2 class="categoryFilters">
      <v-layout row wrap align-content-center justify-center  justify-space-around>
        <v-flex pa-2 :key="category.id" v-for="category in categories" @click="filterCategory(category)" class="cursor-pointer no-select">
          <v-img :style="{'filter': categoryColor(category)}" :src="category.image" class="categoryFilterImage" :class="{'selectedCategory': isFilteredCategory(category)}"/>
          <div class="categoryName">{{ getCategoryName(category.name) }}</div>
        </v-flex>
        <v-flex pa-2 class="cursor-pointer no-select" @click="resetCategoryFilters">
          <v-icon class="resetCategoryFilters d-flex">cancel</v-icon>
          <div class="categoryName">{{ $vuetify.t(`$vuetify.Category.resetFilter`) }}</div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-if="this.sortedIdeas.length === 0" pt-3>
      <v-card class="idea-card" flat>
        <v-card-title><h2>{{ $vuetify.t('$vuetify.IdeaListing.noIdeas') }}</h2></v-card-title>
      </v-card>
    </v-flex>

    <v-flex transition="fade-transition" v-for="idea in this.sortedIdeas" :key="idea.id" sm12 md12 lg12 pa-0>
      <v-card class="idea-card" flat>
        <v-card-title @click="openIdea(idea)">
          <v-layout row>
            <v-flex md10>
              <v-tooltip class="winner" bottom>
                <v-img slot="activator" src="/static/img/icons/idea-winner.png" width="44" height="44" v-if="isWinner(idea)"/>
                  <span> {{ $vuetify.t('$vuetify.Topic.winnerIdea') }}</span>
              </v-tooltip>
              <div v-if="idea.feasible && topic.phase !== 'edit_topics'">
                <div v-if="idea.feasible[0] && idea.feasible[0].val !== undefined">
                  <v-tooltip bottom>
                    <v-icon slot="activator" class="possible" color="primary" v-if="idea.feasible[0].val">check_circle</v-icon>
                    <span> {{ $vuetify.t('$vuetify.IdeaListing.isFeasible') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-icon slot="activator" class="possible" color="error" v-if="!idea.feasible[0].val">cancel</v-icon>
                    <span> {{ $vuetify.t('$vuetify.IdeaListing.isNotFeasible') }}</span>
                  </v-tooltip>
                </div>
                <v-tooltip bottom v-else>
                  <v-icon slot="activator" class="possible" color="secondary" >help</v-icon>
                  <span> {{ $vuetify.t('$vuetify.IdeaListing.waitingForFeasibility') }}</span>
                </v-tooltip>
              </div>
              <h3 class="translate">{{ idea.title }}</h3>
              <div class="card-meta">
                {{ $vuetify.t('$vuetify.IdeaListing.ideaSubtitle',
                getAuthorName(idea),
                getCreatedDate(idea)) }}
              </div>
            </v-flex>
            <v-flex>
            <v-tooltip bottom>
              <v-img class="idea-category" slot="activator" v-if="idea.category" :src="idea.category.image" width="44" height="44"/>
              <span v-if="idea.category">{{ idea.category.name }}</span>
            </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-layout column>
            <v-flex xs12 class="text-xs-left suggestions">
              <v-container pl-0 pr-0 pt-2 pb-2 fill-height>
                <v-layout row>
                  <v-flex pl-2 pr-2>
                    <v-icon>comment</v-icon>
                    <span
                      v-if="getSuggestionCount(idea) === 0"
                      class="no-suggestions"
                    >{{ $vuetify.t('$vuetify.IdeaListing.noComments') }}</span>
                    <span v-else>
                      {{ $vuetify.t(
                      '$vuetify.IdeaListing.numComments',
                      getSuggestionCount(idea))
                      }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>

            <v-flex pl-2 pr-2 v-if="topic == null" class="suppporters">
              <ProgressBar :proVotes="getSupporterCount(idea)"
                :showQuorum="true"
                :idea="idea"
                :small="true"></ProgressBar>
            </v-flex>

            <v-flex pl-2 pr-2 pb-2 v-else-if="topic.phase === 'vote' || topic.phase === 'finished'" class="showing-votes">
              <ProgressBar :proVotes="getVotesPro(idea)"
                :contraVotes="getVotesAgainst(idea)"
                :showQuorum="false"
                :idea="idea"
                :small="true"></ProgressBar>
            </v-flex>

          </v-layout>

        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import ProgressBar from '@/components/util/ProgressBar'
import TranslateButton from './TranslateButton.vue'

export default {
  name: 'IdeaListing',
  components: { ProgressBar, TranslateButton },
  // Ideas list should have created_by(username), comment(count),
  // idea_vote(created_by) and feasible(val) embedded
  props: ['ideas', 'topic', 'quorum', 'categories'],

  data: function () {
    return {
      orderBy: 0,
      query: '',
      filterCategoryId: []
    }
  },

  computed: {
    userId: function () {
      return this.$store.getters.userId
    },
    spaceName: function () {
      return this.$route.params['spaceSlug']
    },
    sortOptions: function () {
      if (this.topic == null) {
        return ['Age', 'Supporters']
      } else if (this.topic.phase === 'edit_topics') {
        return ['RecentComments', 'Name', 'Random']
      } else if (this.topic.phase === 'feasibility') {
        return ['Feasibility', 'Name']
      } else if (this.topic.phase === 'vote') {
        return ['Random']
      } else if (this.topic.phase === 'finished') {
        return ['Result', 'Name']
      }
    },
    sortedIdeas: function () {
      // Apply search query before sorting
      var ideaSet = this.query === ''
        ? Object.assign([], this.ideas)
        : Object.assign([], this.ideas)
          .filter(idea =>
            idea.title.toLowerCase().indexOf(this.query.toLowerCase()) !== -1 ||
            idea.description.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
          )

      const sortFn = {
        Age: (a, b) => a.created_at > b.created_at ? -1 : 1, // eslint-disable-line
        Supporters: (a, b) => // eslint-disable-line
          this.getSupporterCount(a) > this.getSupporterCount(b) ? -1 : 1,
        Name: (a, b) => a.title === b.title ? 0 : a.title > b.title ? 1 : -1, // eslint-disable-line,
        Random: (a, b) => 0.5 - Math.random(),
        Result: (a, b) => {
          let aSupport = this.getSupporterCount(a)
          let bSupport = this.getSupporterCount(b)
          if (a.selected) {
            if (!b.selected) {
              return -1
            } else {
              return 0
            }
          }
          if (b.selected) { return 1 }
          if (aSupport > bSupport) { return -1 }
          if (aSupport < bSupport) { return 1 }
        },
        Feasibility: (a, b) => {
          if (!a.feasible[0]) {
            return -1
          }
          if (!b.feasible[0]) {
            return 1
          }
          if ((a.feasible[0].val && b.feasible[0].val) || (!a.feasible[0].val && !b.feasible[0].val)) {
            return 0
          }
          if (a.feasible[0].val && !b.feasible[0].val) {
            return -1
          }
          if (!a.feasible[0].val && b.feasible[0].val) {
            return 1
          }
        },
        RecentComments: (a, b) => {
          if (this.getSuggestionCount(a) === 0) {
            if (this.getSuggestionCount(b) === 0) return 0
            return 1
          }
          if (this.getSuggestionCount(b) === 0) return -1
          return this.getLastSuggestionDate(a) < this.getLastSuggestionDate(b) ? 1 : -1
        }
      }

      const fn = sortFn[this.sortOptions[this.orderBy]]
      ideaSet.sort(fn)
      if (this.filterCategoryId.length !== 0) {
        ideaSet = ideaSet.filter(c => this.filterCategoryId.indexOf(c.category.id) >= 0)
      }
      if (this.topic &&
      (this.topic.phase === 'vote' || this.topic.phase === 'finished')) {
        ideaSet = ideaSet.filter(i => i.feasible && i.feasible[0] && i.feasible[0].val === true)
      }
      return ideaSet
    }
  },

  beforeMount: function () {
  },

  mounted: function () {
  },

  methods: {
    resetCategoryFilters: function () {
      this.filterCategoryId = []
    },
    categoryColor: function (category) {
      if (!this.isFilteredCategory(category)) {
        return 'grayscale(1)'
      } else {
        return 'none'
      }
    },
    isFilteredCategory: function (category) {
      return this.filterCategoryId.indexOf(category.id) >= 0
    },
    filterCategory: function (category) {
      let categoryIdPos = this.filterCategoryId.indexOf(category.id)
      if (categoryIdPos < 0) {
        this.filterCategoryId.push(category.id)
      } else {
        this.filterCategoryId.splice(categoryIdPos, 1)
      }
    },
    isWinner: function (idea) {
      if (idea.selected) {
        return true
      } else {
        return false
      }
    },
    openIdea: function (idea) {
      this.$router.push({
        name: 'IdeaView',
        params: {
          spaceSlug: this.spaceName,
          ideaId: idea.id
        }
      })
    },
    getAuthorName (idea) {
      if (idea.created_by === null) {
        return this.$vuetify.t('$vuetify.UserProfile.unknown')
      } else {
        if (typeof idea.created_by === 'object') {
          return `${idea.created_by.username}`
        } else {
          return `Author #${idea.created_by}`
        }
      }
    },
    getCategoryName (categoryName) {
      const consoleErr = console.error
      console.error = function () {}
      const name = this.$vuetify.t('$vuetify.IdeaCategories.' + categoryName)
      console.error = consoleErr
      if (name.indexOf('$vuetify') !== -1) {
        return categoryName
      }
      return name
    },
    getCreatedDate (idea) {
      return new Date(idea.created_at).toLocaleDateString()
    },
    getSuggestionCount (idea) {
      return idea.comment ? idea.comment[0].count : 0
    },
    getVotesPro (idea) {
      return idea.idea_vote != null && idea.idea_vote.filter(v => v.val === 'yes').length
    },
    getVotesAgainst (idea) {
      return idea.idea_vote != null && idea.idea_vote.filter(v => v.val === 'no').length
    },
    getLastSuggestionDate (idea) {
      if (idea.comment.length === 0) return null
      const lastComment = Object.assign([], idea.comment)
        .sort((a, b) => a.created_at > b.created_at ? 1 : -1)
        .shift()
      return lastComment.created_at
    },
    getSupporterCount (idea) {
      return idea.idea_vote != null
        ? idea.idea_vote.length
        : null
    },
    isSupportedByUser (idea) {
      return idea.idea_vote
        .filter(vote => vote.created_by === this.userId)
        .length > 0
    },
    isIdeaFeasible (idea) {
      return !idea.feasible || !idea.feasible[0] || !idea.feasible[0].val
        ? null
        : idea.feasible[0].val
    }
  }
}
</script>

<style scoped lang="scss">
  $categoryFilterHeight: 62px;
  $categoryFilterWidth: 62px;

.tab-icon {
  margin: auto 10px;
}

.idea-category {
  float: right;
}

.winner {
  float: left;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.possible {
  float: left;
  font-size: 30px;
  font-weight: 500;
}

.idea-card {
  margin: 10px;
  border-radius: 7px;
  text-align: left;

  .v-card__title {
    cursor: pointer;
    border-bottom: 3px solid #eee !important;
    padding: 12px;

    h3 {
      font-size: 1.6em;
      line-height: 1.4em;
    }

    .card-meta {
      font-size: 14px;
    }
  }

  .v-card__text {
    padding: 0;
  }

  .v-list__tile span {
    font-size: 14px;
  }

  .categories {
    padding-left: 10px;
    align-self: center;

    .v-image {
       float: right;
    }
  }

  .suggestions {
  }

  .v-divider {
    border-color: #eee;
  }

  .v-icon {
    margin-right: 10px;
  }

  .no-supporters,
  .no-suggestions {
    color: grey;
  }

  .idea-supported,
  .idea-supported .v-icon,
  .feasible,
  .feasible .v-icon {
    color: var(--v-primary-base);
  }
  .not-feasible,
  .not-feasible .v-icon{
    color: var(--v-error-base)
  }

  .showing-votes i:nth-child(2) {
    margin-left: 10px;
  }

}

.v-responsive {
  &.v-image {
		&.categoryFilter {
  		.v-image__image {
				&.v-image__image--cover {
    			filter: grayscale(1);
				}
			}
		}
  }
}

.selectedCategory {
   filter: none;
}

.categoryFilters {

  .categoryItemDimensions {
    height: $categoryFilterHeight;
    width: $categoryFilterWidth;
  }

  .categoryFilterImage {
    @extend .categoryItemDimensions;
    margin: 0 auto;
  }

  .categoryName {
    text-align: center;
    word-break: break-word;
    padding: .5rem 0 0 0;
  }

  .resetCategoryFilters {
    @extend .categoryItemDimensions;
    margin: 0 auto;
  }
}

  .cursor-pointer{
    cursor: pointer;
  }

  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }

</style>
